import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function useSchoolIdForAdmin(adminId?: number) {
  return useQuery({
    queryKey: ["schoolIdForAdmin", adminId],
    queryFn: async () => {
      if (!adminId) return null;
      
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/schools/admin/${adminId}`);
        return response.data; // assuming backend returns just the schoolId as a number
      } catch (error: any) {
        // If it's a 404, it means no school found for this admin
        if (error.response?.status === 404) {
          return null;
        }
        
        // For other errors, re-throw to let React Query handle it
        throw error;
      }
    },
    enabled: !!adminId,
    staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh for 5 minutes (prevents constant refetching)
    cacheTime: 30 * 60 * 1000, // 30 minutes - data stays in cache for 30 minutes
    refetchOnWindowFocus: false, // Don't refetch on window focus to prevent excessive API calls
    refetchOnMount: false, // Use cached data instead of refetching on every mount
    refetchOnReconnect: false, // Don't refetch on reconnect
    retry: 1, // Only retry once to avoid excessive API calls
  });
}
